const setHeaderHeightAsCssProp = () => {
  const container = document.getElementsByClassName("cpb-preview-container")[0];
  const header = document.getElementById("header");
  const headerHeight = `${header.clientHeight - 5}px`;

  container.style.setProperty("--header-height", headerHeight);
};

document.body.addEventListener(
  "CPB_ON_PRODUCT_MOUNTED",
  setHeaderHeightAsCssProp
);

